export default function TestError() {
  throw new Error('An error has occurred.');
}
